export default __webpack_public_path__ + "static/media/bathroom1-after-768w.35b7c1f6.png";